<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap v-if="currentUserRoleID<=2 || currentUserRoleID >= 3">
                <v-flex sm12 lg12>

                    <v-layout row wrap>
                        <v-flex sm12 lg12>

                            <!-- v-card  -->
                            <v-card class="mb-4">
                                <v-expansion-panel v-model="expandedModel" expand>
                                    <v-expansion-panel-content class="teal">
                                        <div slot="header" >
                                            <span class="white--text">
                                                All AMS-0004 ATC Service Report AMS
                                                <strong class="black--text ml-2">

                                                </strong>
                                            </span>
                                        </div>
                                        <v-divider></v-divider>

                                        <v-card-text class="white">

                                            <!-- bulk edit actions  -->
                                            <v-flex xs12 v-if="selected.length>0 && showBulkSignButton">
                                                <v-layout row align-start justify-end mr-2>
                                                    <p class="text-lg-right caption grey--text">
                                                        Bulk Actions:
                                                        <v-layout row align-end justify-end mt-2>
                                                            <div class="">
                                                                <v-btn color="info" v-on:click="navigateToBulkDialogPage">
                                                                    <span class="">SBST Sign</span>
                                                                </v-btn>
                                                            </div>
                                                        </v-layout>
                                                    </p>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm12 md12 mt-3>
                                               <v-data-table
                                                    v-model="selected"
                                                    :headers="fvs.headers"
                                                    :items="items"
                                                    item-key="id"
                                                    hide-actions
                                                    select-all
                                                    class="elevation-1"
                                                >
                                                    <template slot="headers" slot-scope="props">
                                                        <tr>
                                                            <th>
                                                                <v-checkbox
                                                                    :input-value="props.all"
                                                                    :indeterminate="props.indeterminate"
                                                                    primary
                                                                    hide-details
                                                                    @click.stop="toggleAll"
                                                                ></v-checkbox>
                                                            </th>
                                                            <th
                                                                v-for="header in props.headers"
                                                                :key="header.text"
                                                                :class="['column sortable']"
                                                            >
                                                                {{ header.text }}
                                                            </th>
                                                        </tr>
                                                    </template>
                                                    <template
                                                        slot="items" slot-scope="props"
                                                    >
                                                         <tr :active="props.selected" @click="props.selected = !props.selected">
                                                            <td>
                                                                <v-checkbox
                                                                    :input-value="props.selected"
                                                                    primary
                                                                    hide-details
                                                                ></v-checkbox>
                                                            </td>
                                                            <td>{{ (props.index + 1)+((current_page_id-1)*per_page) }}</td>
                                                            <td class="text-xs-left"><span class="">{{ props.item.checklist_no }}</span></td>
                                                            <td class="text-xs-left"><span class="">{{ props.item.date }}</span></td>
                                                            <td class="text-xs-left"><span class="">{{ props.item.time }}</span></td>
                                                            <!-- <td class="text-xs-left"><span class="">{{ getActivatedName(props.item.activated) }}</span></td> -->
                                                            <td>
                                                                <v-layout row wrap>
                                                                    <v-flex xs4 pa-2>
                                                                        <v-btn
                                                                            fab outline small color="success"
                                                                            v-on:click="openViewDialogAction(props.item)"
                                                                        >
                                                                            <v-icon>visibility</v-icon>
                                                                        </v-btn>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </td>
                                                            <td>
                                                                <v-layout row wrap>
                                                                    <v-flex xs4 pa-2>
                                                                        <v-btn
                                                                            fab outline small color="light-blue"
                                                                            v-on:click="openEditDialogAction(props.item)"
                                                                        >
                                                                            <v-icon>edit</v-icon>
                                                                        </v-btn>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </td>

                                                            <td>
                                                                <v-layout row wrap>
                                                                    <v-flex xs4 pa-2>
                                                                        <v-btn
                                                                            fab outline small color="light-blue"
                                                                            v-on:click="downloadReportNow(props.item)"
                                                                        >
                                                                            <v-icon>cloud_download</v-icon>
                                                                        </v-btn>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </td>

                                                            <td>
                                                                <v-layout row wrap>
                                                                    <v-flex xs4 pa-2>
                                                                        <v-btn
                                                                            fab outline small color="red"
                                                                            v-on:click="openDeleteDialogAction(props.item)"
                                                                        >
                                                                            <v-icon>delete</v-icon>
                                                                        </v-btn>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                                <v-flex mt-5>
                                                    <app-vue-pagination :collection.sync="collection"></app-vue-pagination>
                                                </v-flex>
                                            </v-flex>

                                            <v-layout row mt-5>
                                                <!-- fab button  -->
                                                <v-btn
                                                    color="pink" dark absolute
                                                    bottom right fab
                                                    title="Add New Franchise Category"
                                                    v-on:click="openAddDialogAction"
                                                  >
                                                    <v-icon>add</v-icon>
                                                </v-btn>
                                            </v-layout>
                                        </v-card-text>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-card>

                        </v-flex>
                    </v-layout>

                    <!-- dialog modal  -->

                    <!-- view & download dialog -->
                    <v-layout row justify-center v-if="selectedObj != null">
                        <app-vue-html2pdf
                            :show-layout="false"
                            :enable-download="true"
                            :preview-modal="false"
                            :paginate-elements-by-height="2000"
                            :filename="selectedObj.report_no"
                            :pdf-quality="3"
                            :manual-pagination="true"
                            pdf-format="a4"
                            pdf-orientation="portrait"
                            pdf-content-width="800px"
                            :html2canvas="html2canvasOptions"
                            
                            @progress="onProgress($event)"
                            @hasStartedGeneration="hasStartedGeneration()"
                            @hasGenerated="hasGenerated($event)"
                            ref="html2Pdf"
                        >
                            <section slot="pdf-content">
                                <!-- page 1  -->
                                <div class="pdf-item container border-container" v-if="selectedObj != null">
                                    <!-- header  -->
                                    <div class="mt2">
                                        <h2 class="pdf-header textBlack" style="border-bottom: 1px solid #000;">
                                            AMS-0004 ATC Service Report
                                        </h2>
                                    </div>
                                    <div style="margin-top: 10px">
                                        <v-layout row wrap>
                                            <v-flex md6 xs6>
                                                <v-layout row wrap>
                                                    <v-flex md3 xs3>
                                                        <span>
                                                            <strong>Location :</strong>
                                                        </span>
                                                    </v-flex>
                                                    <v-flex md9 xs9>
                                                        <span>
                                                            {{ allStations[selectedObj.station_id] != null ? `${allStations[selectedObj.station_id].station_no} - ${allStations[selectedObj.station_id].station_name}` : 'N/A' }}
                                                        </span>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex md6 xs6>
                                                <v-layout row wrap>
                                                    <v-flex md3 xs3>
                                                        <span>
                                                            <strong>Date :</strong>
                                                        </span>
                                                    </v-flex>
                                                    <v-flex md9 xs9>
                                                        <span>
                                                            {{ selectedObj.date  }}
                                                        </span>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>

                                        <v-layout row wrap>
                                            <v-flex md6 xs6>
                                                <v-layout row wrap>
                                                    <v-flex md3 xs3>
                                                        <span>
                                                            <strong>Engineer :</strong>
                                                        </span>
                                                    </v-flex>
                                                    <v-flex md9 xs9>
                                                        <span>
                                                            {{ currentAuthUser.full_name }}
                                                        </span>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex md6 xs6>
                                                <v-layout row wrap>
                                                    <v-flex md3 xs3>
                                                        <span>
                                                            <strong>Time :</strong>
                                                        </span>
                                                    </v-flex>
                                                    <v-flex md9 xs9>
                                                        <span>
                                                            {{ selectedObj.time  }}
                                                        </span>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                    <!-- end of header  -->

                                    <!-- content  -->
                                    <div>
                                        <h3 class="pdf-header textBlack" style="border: 1px solid #000; margin-top: 10px; margin-bottom: 10px;">
                                            Water Cooled Chiller Preventive Maintenance
                                        </h3>

                                        <v-layout row wrap>
                                            <v-flex md4 xs4>
                                                <h4>WCC-01:</h4>
                                                <h4>Serial Number:</h4>
                                                <div style="min-height: 120px">
                                                    {{ selectedObj.other_detail }}
                                                </div>
                                                <h4>Running Hours:</h4>
                                                <div style="min-height: 120px">
                                                    {{ selectedObj.running_hours }}
                                                </div>
                                            </v-flex>
                                            <v-flex md4 xs4>
                                                <h4>Photo</h4>
                                                <div style="min-height: 120px">
                                                    <img :src="selectedObj.pic_1" alt="img" />
                                                    
                                                </div>
                                            </v-flex>
                                            <v-flex md4 xs4>
                                                <h4>Photo</h4>
                                                <div style="min-height: 120px">
                                                    <v-img
                                                        class="img.img-upload"
                                                        :src="selectedObj.pic_2"
                                                        width="120"
                                                        height="120"
                                                    >
                                                    </v-img>
                                                </div>
                                            </v-flex>
                                        </v-layout>

                                        <hr />

                                        <v-layout row wrap mt3 style="margin-top: 10px;">
                                            <v-flex md4 xs4>
                                                <h4>WCC-02</h4>
                                                <h4>Serial Number:</h4>
                                                <div style="min-height: 120px">
                                                    {{ selectedObj.other_detail_2 }}
                                                </div>
                                                <h4>Running Hours</h4>
                                                <div style="min-height: 120px">
                                                    {{ selectedObj.running_hours_2 }}
                                                </div>
                                            </v-flex>
                                            <v-flex md4 xs4>
                                                <h4>Photo</h4>
                                                <div style="min-height: 100px">
                                                    <v-img
                                                        class="img.img-upload"
                                                        :src="selectedObj.pic_3"
                                                        width="120"
                                                        height="120"
                                                    >
                                                    </v-img>
                                                </div>
                                            </v-flex>
                                            <v-flex md4 xs4>
                                                <h4>Photo</h4>
                                                <div style="min-height: 120px">
                                                    <v-img
                                                        class="img.img-upload"
                                                        :src="selectedObj.pic_4"
                                                        width="120"
                                                        height="120"
                                                    >
                                                    </v-img>
                                                </div>
                                            </v-flex>
                                        </v-layout>

                                        <hr />

                                        <v-layout row wrap mt3 style="margin-top: 10px;">
                                            <v-flex md4 xs4>
                                                <h4>WCC-03</h4>
                                                <h4>Serial Number:</h4>
                                                <div style="min-height: 120px">
                                                    {{ selectedObj.other_detail_3 }}
                                                </div>
                                                <h4>Running Hours</h4>
                                                <div style="min-height: 120px">
                                                    {{ selectedObj.running_hours_3 }}
                                                </div>
                                            </v-flex>
                                            <v-flex md4 xs4>
                                                <h4>Photo</h4>
                                                <div style="min-height: 120px">
                                                    <v-img
                                                        class="img.img-upload"
                                                        :src="selectedObj.pic_5"
                                                        width="120"
                                                        height="120"
                                                    >
                                                    </v-img>
                                                </div>
                                            </v-flex>
                                            <v-flex md4 xs4>
                                                <h4>Photo</h4>
                                                <div style="min-height: 120px">
                                                    <v-img
                                                        class="img.img-upload"
                                                        :src="selectedObj.pic_6"
                                                        width="120"
                                                        height="120"
                                                    >
                                                    </v-img>
                                                </div>
                                            </v-flex>
                                        </v-layout>

                                        <hr />

                                        <v-layout row wrap mt3 style="margin-top: 10px;">
                                            <v-flex md12 xs12>
                                                <h4>Comments</h4>
                                                <div>
                                                    <span>
                                                        {{ selectedObj.comments }}
                                                    </span>
                                                </div>
                                            </v-flex>
                                        </v-layout>


                                    </div>

                                </div>

                                <div class="html2pdf__page-break"/>

                                <!-- page 3 -->
                                <div class="pdf-item container border-container">
                                    <!-- header  -->
                                    <div class="mt2">
                                        <h4 class="pdf-header textBlack" style="border-bottom: 1px solid #000;">
                                            General Condition for WCC-01
                                        </h4>
                                    </div>
                                    <div style="margin-top: 10px">
                                        <h4>Check general condition of chiller system.</h4>
                                        <v-layout row wrap>
                                            <v-flex md2 xs2>
                                                <div style="min-height: 65px">
                                                    
                                                </div>
                                            </v-flex>
                                            <v-flex md2 xs2>
                                                <div style="min-height: 65px">
                                                    <h4>Photo</h4>
                                                    <v-img
                                                        class="img.img-upload"
                                                        :src="selectedObj.pic_8"
                                                        width="65"
                                                        height="65"
                                                    >
                                                    </v-img>
                                                </div>
                                            </v-flex>
                                            <v-flex md2 xs2>
                                                <div style="min-height: 65px">
                                                    <h4>Photo</h4>
                                                    <v-img
                                                        class="img.img-upload"
                                                        :src="selectedObj.pic_9"
                                                        width="65"
                                                        height="65"
                                                    >
                                                    </v-img>
                                                </div>
                                            </v-flex>
                                            <v-flex md2 xs2>
                                                <div style="min-height: 65px">
                                                    <h4>Photo</h4>
                                                    <v-img
                                                        class="img.img-upload"
                                                        :src="selectedObj.pic_10"
                                                        width="65"
                                                        height="65"
                                                    >
                                                    </v-img>
                                                </div>
                                            </v-flex>
                                            <v-flex md2 xs2>
                                                <div style="min-height: 65px">
                                                    <h4>Photo</h4>
                                                    <v-img
                                                        class="img.img-upload"
                                                        :src="selectedObj.pic_11"
                                                        width="65"
                                                        height="65"
                                                    >
                                                    </v-img>
                                                </div>
                                            </v-flex>
                                            <v-flex md2 xs2>
                                                <div style="min-height: 65px">
                                                    <h4>Photo</h4>
                                                    <v-img
                                                        class="img.img-upload"
                                                        :src="selectedObj.pic_12"
                                                        width="65"
                                                        height="65"
                                                    >
                                                    </v-img>
                                                </div>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                </div>
                            </section>
                        </app-vue-html2pdf>
                    </v-layout>

                    <!-- view dialog -->
                    <v-layout row justify-center>
                        <v-dialog v-model="openViewDialog"
                            fullscreen hide-overlay
                            transition="dialog-bottom-transition">

                            <v-card>
                                <v-toolbar dark color="teal" fixed>
                                    <v-btn icon dark
                                        @click="openViewDialog = false">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>
                                        <span class="white--text title">
                                            View Engineer Report
                                        </span>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                            dark flat @click="openViewDialog = false">
                                            Close
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-card-text>
                                    <v-card-text class="white">
                                        <v-flex xs12 sm12 md12 style="margin-top: 5%; padding-left: 10px; padding-right: 10px;">
                                            <v-stepper
                                                v-model="e1"
                                                :vertical="vertical"
                                                :alt-labels="altLabels"
                                            >
                                                <v-stepper-header>
                                                    <template v-for="n in steps">
                                                        <v-stepper-step
                                                            :key="`${n}-step`"
                                                            :complete="e1 > n"
                                                            :step="n"
                                                            :editable="editable"
                                                        >
                                                            Page {{ n }}
                                                        </v-stepper-step>

                                                        <v-divider
                                                        v-if="n !== steps"
                                                        :key="n"
                                                        ></v-divider>
                                                    </template>
                                                </v-stepper-header>

                                                <v-stepper-items>

                                                    <!-- Page 1  -->
                                                    <v-stepper-content step="1" >
                                                        <v-card
                                                            class="mb-12"
                                                            color="white"
                                                        >
                                                            <v-layout row wrap>
                                                                <v-flex xs12 md5>
                                                                    <!-- submit date  -->
                                                                    <v-layout row wrap>
                                                                        <v-flex md3 xs12>
                                                                            <v-subheader class="subTitle">Date</v-subheader>
                                                                        </v-flex>
                                                                        <v-flex md9 xs12>
                                                                            <v-menu
                                                                                v-model="editSubmitDateMenu"
                                                                                :close-on-content-click="false"
                                                                                full-width max-width="290"
                                                                            >
                                                                                <v-text-field
                                                                                    slot="activator"
                                                                                    :value="computedEditSubmitDate"
                                                                                    clearable
                                                                                    label="Date"
                                                                                    prepend-icon="calendar_today"
                                                                                    readonly
                                                                                    disabled
                                                                                >
                                                                                </v-text-field>
                                                                                <v-date-picker
                                                                                    v-model="selectedObj.date"
                                                                                    @change="editSubmitDateMenu = false"
                                                                                    >
                                                                                </v-date-picker>
                                                                            </v-menu>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>

                                                                <v-flex xs12 md1></v-flex>

                                                                <v-flex xs12 md5>
                                                                    <!-- Station -->
                                                                    <v-layout row wrap>
                                                                        <v-flex md4 xs12>
                                                                            <v-subheader class="subTitle">Station</v-subheader>
                                                                        </v-flex>
                                                                        <v-flex md8 xs12>
                                                                            <v-select
                                                                                :items="allStations"
                                                                                item-value="id"
                                                                                v-model="selectedObj.station_id"
                                                                                item-text="station_name"
                                                                                single-line
                                                                                label="Stations"
                                                                                persistent-hint
                                                                                hint="Select Station"
                                                                                disabled
                                                                                v-on:change="selectedStationID"
                                                                            >
                                                                                <template slot="selection" slot-scope="data">
                                                                                        {{ data.item.station_no }} - {{ data.item.station_name }}
                                                                                </template>
                                                                                <template slot="item" slot-scope="data">
                                                                                    {{ data.item.station_no }} - {{ data.item.station_name }}
                                                                                </template>
                                                                            </v-select>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>    
                                                            </v-layout>

                                                            <v-layout row wrap md5>
                                                                <v-flex xs12 md5>
                                                                    <!-- submit time  -->
                                                                    <v-layout row wrap>
                                                                        <v-flex md3 xs12>
                                                                            <v-subheader class="subTitle">Time</v-subheader>
                                                                        </v-flex>
                                                                        <v-flex md9 xs12>
                                                                            <v-dialog
                                                                                ref="editTime"
                                                                                v-model="editTimeDialog"
                                                                                :return-value.sync="selectedObj.time"
                                                                                persistent lazy full-width width="290px"
                                                                            >
                                                                                <v-text-field
                                                                                    disabled
                                                                                    slot="activator" v-model="selectedObj.time"
                                                                                    label="Time" prepend-icon="access_time" readonly
                                                                                ></v-text-field>
                                                                                <v-time-picker v-if="editTimeDialog"
                                                                                v-model="selectedObj.time"
                                                                                full-width
                                                                                >
                                                                                <v-spacer></v-spacer>
                                                                                    <v-btn flat color="primary" @click="editTimeDialog = false">Cancel</v-btn>
                                                                                    <v-btn flat color="primary" @click="editTimeDialog = false">OK</v-btn>
                                                                                </v-time-picker>
                                                                            </v-dialog>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>

                                                                <v-flex xs12 md1></v-flex>

                                                                <v-flex xs12 md5>
                                                                    <!-- Engineer -->
                                                                    <v-layout row wrap>
                                                                        <v-flex md4 xs12>
                                                                            <v-subheader class="subTitle">Engineer</v-subheader>
                                                                        </v-flex>
                                                                        <v-flex md8 xs12>
                                                                            <v-text-field
                                                                                type="text"
                                                                                disabled
                                                                                v-model="currentAuthUser.full_name">
                                                                            </v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>    
                                                            </v-layout>

                                                            <v-layout row wrap mb-3 mt-5>
                                                                <v-flex xs12>
                                                                    <div class="sectionHeader">
                                                                        <span>AUTO TUBE CLEANING SYSTEM PREVENTIVE MAINTENANCE</span>
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Please Select</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_of_atcs"
                                                                        item-value="name"
                                                                        v-model="selectedObj.pm_type"
                                                                        item-text="name"
                                                                        single-line
                                                                        disabled
                                                                        label="Follow Up"
                                                                        v-on:change="selectedTypeOfPm"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row wrap mt-3 mb-5></v-layout>

                                                            <!-- horizontal green line  -->
                                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                                <v-flex xs12>
                                                                    <hr style="border: 1px solid green;" />
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Comments"
                                                                        disabled
                                                                        v-model="selectedObj.comments"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card>

                                                        <v-btn
                                                            color="primary"
                                                            @click="nextStep(1)"
                                                        >
                                                            Continue
                                                        </v-btn>
                                                        <v-btn text>Cancel</v-btn>
                                                    </v-stepper-content>

                                                    <!-- Page 2  -->
                                                    <v-stepper-content step="2" >
                                                        <v-card
                                                            class="mb-12"
                                                            color="white"
                                                        >
                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <div class="sectionHeader">
                                                                        <span>Selected: {{ selectedObj.pm_type }}</span>
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                             <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <div class="sectionHeader">
                                                                        <span>Replace Sponge Balls</span>
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <span style="font-style: italic;"><strong>*Replace old sponge balls with new sponge balls</strong></span>
                                                                </v-flex>  
                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile1Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_1)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file1"
                                                                            disabled
                                                                            v-on:change="onFile1Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile2Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_2)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file2"
                                                                            disabled
                                                                            v-on:change="onFile2Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile3Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_3)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file3"
                                                                            disabled
                                                                            v-on:change="onFile3Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3>
                                                                <v-flex xs5>
                                                                    <v-subheader class="subTitle">
                                                                       <h4><strong>Number of old sponge balls removed</strong></h4>
                                                                    </v-subheader>
                                                                </v-flex>
                                                                <v-flex xs2></v-flex>
                                                                <v-flex xs5>
                                                                    <v-subheader class="subTitle">
                                                                       <h4><strong>Number of new sponge balls put in</strong></h4>
                                                                    </v-subheader>
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-text-field
                                                                        disabled
                                                                        type="number"
                                                                        v-model="selectedObj.num_of_old_sponge"
                                                                    >
                                                                    </v-text-field>
                                                                </v-flex>
                                                                <v-flex xs2></v-flex>
                                                                <v-flex xs5>
                                                                    <v-text-field
                                                                        disabled
                                                                        type="number"
                                                                        v-model="selectedObj.num_of_new_sponge"
                                                                    >
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Remarks"
                                                                        disabled
                                                                        v-model="selectedObj.remarks"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Followed Up</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_follow_ups"
                                                                        item-value="name"
                                                                        v-model="selectedObj.followed_up"
                                                                        item-text="name"
                                                                        single-line
                                                                        disabled
                                                                        label="Follow Up"
                                                                        v-on:change="selectedFollowedUp"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>

                                                            <!-- horizontal green line  -->
                                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                                <v-flex xs12>
                                                                    <hr style="border: 1px solid green;" />
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <span style="font-style: italic;">
                                                                        *Test <strong>SEND</strong> Mode
                                                                    </span>
                                                                </v-flex>  
                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile4Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_4)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file4"
                                                                            disabled
                                                                            v-on:change="onFile4Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile5Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_5)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file5"
                                                                            disabled
                                                                            v-on:change="onFile5Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile6Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_6)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file6"
                                                                            disabled
                                                                            v-on:change="onFile6Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3>
                                                                <v-flex xs12>
                                                                    <v-subheader class="subTitle">
                                                                       <h4><strong>Status : {{ selectedObj.status }}</strong></h4>
                                                                    </v-subheader>
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        disabled
                                                                        style="width: 100%;"
                                                                        :color="selectedObj.status != null ? (selectedObj.status == 'done' ? 'green' : '#ccc') : '#ccc'"
                                                                        @click="toggleStatus('done')"
                                                                    >
                                                                        <v-icon :color="selectedObj.status != null ? (selectedObj.status == 'done' ? 'white' : '#000') : '#000'">checked</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                                <v-flex xs2></v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        disabled
                                                                        style="width: 100%;"
                                                                        :color="selectedObj.status != null ? (selectedObj.status == 'fail' ? 'red' : '#ccc') : '#ccc'"
                                                                        @click="toggleStatus('fail')"
                                                                    >
                                                                        <v-icon :color="selectedObj.status != null ? (selectedObj.status == 'fail' ? 'white' : '#000') : '#000'">close</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Remarks"
                                                                        disabled
                                                                        v-model="selectedObj.remarks_2"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Followed Up</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_follow_ups"
                                                                        item-value="name"
                                                                        v-model="selectedObj.followed_up_2"
                                                                        item-text="name"
                                                                        single-line
                                                                        disabled
                                                                        label="Follow Up"
                                                                        v-on:change="selectedFollowedUp2"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>

                                                            <!-- horizontal green line  -->
                                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                                <v-flex xs12>
                                                                    <hr style="border: 1px solid green;" />
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <span style="font-style: italic;">
                                                                        *Test <strong>RETURN</strong> Mode
                                                                    </span>
                                                                </v-flex>  
                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile7Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_7)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file7"
                                                                            disabled
                                                                            v-on:change="onFile7Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile8Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_8)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file8"
                                                                            disabled
                                                                            v-on:change="onFile8Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile9Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_9)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file9"
                                                                            disabled
                                                                            v-on:change="onFile9Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3>
                                                                <v-flex xs12>
                                                                    <v-subheader class="subTitle">
                                                                       <h4><strong>Status : {{ selectedObj.status_2 }}</strong></h4>
                                                                    </v-subheader>
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        disabled
                                                                        style="width: 100%;"
                                                                        :color="selectedObj.status_2 != null ? (selectedObj.status_2 == 'done' ? 'green' : '#ccc') : '#ccc'"
                                                                        @click="toggleStatus2('done')"
                                                                    >
                                                                        <v-icon :color="selectedObj.status_2 != null ? (selectedObj.status_2 == 'done' ? 'white' : '#000') : '#000'">checked</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                                <v-flex xs2></v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        disabled
                                                                        style="width: 100%;"
                                                                        :color="selectedObj.status_2 != null ? (selectedObj.status_2 == 'fail' ? 'red' : '#ccc') : '#ccc'"
                                                                        @click="toggleStatus2('fail')"
                                                                    >
                                                                        <v-icon :color="selectedObj.status_2 != null ? (selectedObj.status_2 == 'fail' ? 'white' : '#000') : '#000'">close</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Remarks"
                                                                        disabled
                                                                        v-model="selectedObj.remarks_3"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Followed Up</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_follow_ups"
                                                                        item-value="name"
                                                                        v-model="selectedObj.followed_up_3"
                                                                        item-text="name"
                                                                        single-line
                                                                        disabled
                                                                        label="Follow Up"
                                                                        v-on:change="selectedFollowedUp3"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>

                                                            <!-- horizontal green line  -->
                                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                                <v-flex xs12>
                                                                    <hr style="border: 1px solid green;" />
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <span style="font-style: italic;">
                                                                        *Test <strong>REST</strong> Mode
                                                                    </span>
                                                                </v-flex>  
                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile7Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_10)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file10"
                                                                            disabled
                                                                            v-on:change="onFile10Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile11Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_11)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file11"
                                                                            disabled
                                                                            v-on:change="onFile11Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile12Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_12)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file12"
                                                                            disabled
                                                                            v-on:change="onFile12Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3>
                                                                <v-flex xs12>
                                                                    <v-subheader class="subTitle">
                                                                       <h4><strong>Status : {{ selectedObj.status_3 }}</strong></h4>
                                                                    </v-subheader>
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        disabled
                                                                        style="width: 100%;"
                                                                        :color="selectedObj.status_3 != null ? (selectedObj.status_3 == 'done' ? 'green' : '#ccc') : '#ccc'"
                                                                        @click="toggleStatus3('done')"
                                                                    >
                                                                        <v-icon :color="selectedObj.status_3 != null ? (selectedObj.status_3 == 'done' ? 'white' : '#000') : '#000'">checked</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                                <v-flex xs2></v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        disabled
                                                                        style="width: 100%;"
                                                                        :color="selectedObj.status_3 != null ? (selectedObj.status_3 == 'fail' ? 'red' : '#ccc') : '#ccc'"
                                                                        @click="toggleStatus3('fail')"
                                                                    >
                                                                        <v-icon :color="selectedObj.status_3 != null ? (selectedObj.status_3 == 'fail' ? 'white' : '#000') : '#000'">close</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Remarks"
                                                                        disabled
                                                                        v-model="selectedObj.remarks_4"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Followed Up</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_follow_ups"
                                                                        item-value="name"
                                                                        v-model="selectedObj.followed_up_4"
                                                                        item-text="name"
                                                                        single-line
                                                                        disabled
                                                                        label="Follow Up"
                                                                        v-on:change="selectedFollowedUp4"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5></v-layout>
                                                        </v-card>
                                                        <v-btn
                                                            color="primary"
                                                            @click="nextStep(2)"
                                                        >
                                                            Continue
                                                        </v-btn>
                                                        <v-btn text>Cancel</v-btn>
                                                    </v-stepper-content>

                                                    <!-- Page 3  -->
                                                    <v-stepper-content step="3" >
                                                        <v-card
                                                            class="mb-12"
                                                            color="white"
                                                        >
                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <div class="sectionHeader">
                                                                        <span>Defects</span>
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mb-3> 
                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile13Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_13)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file13"
                                                                            disabled
                                                                            v-on:change="onFile13Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile14Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_14)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file14"
                                                                            disabled
                                                                            v-on:change="onFile14Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile15Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_15)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file15"
                                                                            disabled
                                                                            v-on:change="onFile15Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Remarks"
                                                                        disabled
                                                                        v-model="selectedObj.remarks_5"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Followed Up</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_follow_ups"
                                                                        item-value="name"
                                                                        v-model="selectedObj.followed_up_5"
                                                                        item-text="name"
                                                                        single-line
                                                                        disabled
                                                                        label="Follow Up"
                                                                        v-on:change="selectedFollowedUp5"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row wrap mt-3 mb-5></v-layout>
                                                            <v-btn
                                                                color="primary"
                                                                @click="openViewDialog = false"
                                                            >
                                                                Close
                                                            </v-btn>
                                                        </v-card>
                                                    </v-stepper-content>
                                                </v-stepper-items>
                                            </v-stepper>


                                        </v-flex>
                                    </v-card-text>
                                </v-card-text>
                          </v-card>
                        </v-dialog>
                    </v-layout>

                    <!-- create dialog -->
                    <v-layout row justify-center>
                        <v-dialog v-model="openAddDialog"
                            fullscreen hide-overlay
                            transition="dialog-bottom-transition">

                            <v-card>
                                <v-toolbar dark color="teal" fixed>
                                    <v-btn icon dark
                                        @click="openAddDialog = false">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>
                                        <span class="white--text title">
                                            Add New Engineer Report and Checklist
                                        </span>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                            dark flat @click="addResourceAction">
                                            Save &amp; Submit
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-card-text>
                                    <v-card-text class="white">
                                        <v-flex xs12 sm12 md12 style="margin-top: 5%; padding-left: 10px; padding-right: 10px;">
                                            <v-stepper
                                                v-model="e1"
                                                :vertical="vertical"
                                                :alt-labels="altLabels"
                                            >
                                                <v-stepper-header>
                                                    <template v-for="n in steps">
                                                        <v-stepper-step
                                                            :key="`${n}-step`"
                                                            :complete="e1 > n"
                                                            :step="n"
                                                            :editable="editable"
                                                        >
                                                            Page {{ n }}
                                                        </v-stepper-step>

                                                        <v-divider
                                                        v-if="n !== steps"
                                                        :key="n"
                                                        ></v-divider>
                                                    </template>
                                                </v-stepper-header>

                                                <v-stepper-items>

                                                    <!-- Page 1  -->
                                                    <v-stepper-content step="1" >
                                                        <v-card
                                                            class="mb-12"
                                                            color="white"
                                                        >
                                                            <v-layout row wrap>
                                                                <v-flex xs12 md5>
                                                                    <!-- submit date  -->
                                                                    <v-layout row wrap>
                                                                        <v-flex md3 xs12>
                                                                            <v-subheader class="subTitle">Date</v-subheader>
                                                                        </v-flex>
                                                                        <v-flex md9 xs12>
                                                                            <v-menu
                                                                                v-model="newSubmitDateMenu"
                                                                                :close-on-content-click="false"
                                                                                full-width max-width="290"
                                                                            >
                                                                                <v-text-field
                                                                                    slot="activator"
                                                                                    :value="computedNewSubmitDate"
                                                                                    clearable
                                                                                    label="Date"
                                                                                    prepend-icon="calendar_today"
                                                                                    readonly
                                                                                    
                                                                                >
                                                                                </v-text-field>
                                                                                <v-date-picker
                                                                                    v-model="newSelectedObj.date"
                                                                                    @change="newSubmitDateMenu = false"
                                                                                    >
                                                                                </v-date-picker>
                                                                            </v-menu>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>

                                                                <v-flex xs12 md1></v-flex>

                                                                <v-flex xs12 md5>
                                                                    <!-- Station -->
                                                                    <v-layout row wrap>
                                                                        <v-flex md4 xs12>
                                                                            <v-subheader class="subTitle">Station</v-subheader>
                                                                        </v-flex>
                                                                        <v-flex md8 xs12>
                                                                            <v-select
                                                                                :items="allStations"
                                                                                item-value="id"
                                                                                v-model="newSelectedObj.station_id"
                                                                                item-text="station_name"
                                                                                single-line
                                                                                label="Stations"
                                                                                persistent-hint
                                                                                hint="Select Station"
                                                                                v-on:change="selectedNewStationID"
                                                                            >
                                                                                <template slot="selection" slot-scope="data">
                                                                                        {{ data.item.station_no }} - {{ data.item.station_name }}
                                                                                </template>
                                                                                <template slot="item" slot-scope="data">
                                                                                    {{ data.item.station_no }} - {{ data.item.station_name }}
                                                                                </template>
                                                                            </v-select>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>    
                                                            </v-layout>

                                                            <v-layout row wrap md5>
                                                                <v-flex xs12 md5>
                                                                    <!-- submit time  -->
                                                                    <v-layout row wrap>
                                                                        <v-flex md3 xs12>
                                                                            <v-subheader class="subTitle">Time</v-subheader>
                                                                        </v-flex>
                                                                        <v-flex md9 xs12>
                                                                            <v-dialog
                                                                                ref="newTime"
                                                                                v-model="newTimeDialog"
                                                                                :return-value.sync="newSelectedObj.time"
                                                                                persistent lazy full-width width="290px"
                                                                            >
                                                                                <v-text-field
                                                                                    
                                                                                    slot="activator" v-model="newSelectedObj.time"
                                                                                    label="Time" prepend-icon="access_time" readonly
                                                                                ></v-text-field>
                                                                                <v-time-picker v-if="newTimeDialog"
                                                                                v-model="newSelectedObj.time"
                                                                                full-width
                                                                                >
                                                                                <v-spacer></v-spacer>
                                                                                    <v-btn flat color="primary" @click="newTimeDialog = false">Cancel</v-btn>
                                                                                    <v-btn flat color="primary" @click="newTimePicker">OK</v-btn>
                                                                                </v-time-picker>
                                                                            </v-dialog>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>

                                                                <v-flex xs12 md1></v-flex>

                                                                <v-flex xs12 md5>
                                                                    <!-- Engineer -->
                                                                    <v-layout row wrap>
                                                                        <v-flex md4 xs12>
                                                                            <v-subheader class="subTitle">Engineer</v-subheader>
                                                                        </v-flex>
                                                                        <v-flex md8 xs12>
                                                                            <v-text-field
                                                                                type="text"
                                                                                
                                                                                v-model="currentAuthUser.full_name">
                                                                            </v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>    
                                                            </v-layout>

                                                            <v-layout row wrap mb-3 mt-5>
                                                                <v-flex xs12>
                                                                    <div class="sectionHeader">
                                                                        <span>Compress Air System Preventive Maintenance</span>
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Please Select</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_of_atcs"
                                                                        item-value="name"
                                                                        v-model="newSelectedObj.pm_type"
                                                                        item-text="name"
                                                                        single-line
                                                                        
                                                                        label="Follow Up"
                                                                        v-on:change="selectedTypeOfPm"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row wrap mt-3 mb-5></v-layout>

                                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                                <v-flex xs12>
                                                                    <hr style="border: 1px solid green;" />
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Comments"
                                                                        
                                                                        v-model="newSelectedObj.comments"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card>

                                                        <v-btn
                                                            color="primary"
                                                            @click="nextStep(1)"
                                                        >
                                                            Continue
                                                        </v-btn>
                                                        <v-btn text>Cancel</v-btn>
                                                    </v-stepper-content>

                                                    <!-- Page 2  -->
                                                    <v-stepper-content step="2" >
                                                        <v-card
                                                            class="mb-12"
                                                            color="white"
                                                        >
                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <div class="sectionHeader">
                                                                        <span>Selected: {{ newSelectedObj.pm_type }}</span>
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                             <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <div class="sectionHeader">
                                                                        <span>Work Done on Equipment</span>
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mb-3>    
                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchNewFile1Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(newSelectedObj.pic_1)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="newfile1"
                                                                            
                                                                            v-on:change="onNewFile1Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchNewFile2Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(newSelectedObj.pic_2)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="newfile2"
                                                                            
                                                                            v-on:change="onNewFile2Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchNewFile3Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(newSelectedObj.pic_3)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="newfile3"
                                                                            
                                                                            v-on:change="onNewFile3Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3>
                                                                <v-flex xs12>
                                                                    <v-subheader class="subTitle">
                                                                       <h4><strong>Status : {{ newSelectedObj.status }}</strong></h4>
                                                                    </v-subheader>
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        
                                                                        style="width: 100%;"
                                                                        :color="newSelectedObj.status != null ? (newSelectedObj.status == 'done' ? 'green' : '#ccc') : '#ccc'"
                                                                        @click="toggleNewStatus('done')"
                                                                    >
                                                                        <v-icon :color="newSelectedObj.status != null ? (newSelectedObj.status == 'done' ? 'white' : '#000') : '#000'">checked</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                                <v-flex xs2></v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        
                                                                        style="width: 100%;"
                                                                        :color="newSelectedObj.status != null ? (newSelectedObj.status == 'fail' ? 'red' : '#ccc') : '#ccc'"
                                                                        @click="toggleNewStatus('fail')"
                                                                    >
                                                                        <v-icon :color="newSelectedObj.status != null ? (newSelectedObj.status == 'fail' ? 'white' : '#000') : '#000'">close</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Remarks"
                                                                        
                                                                        v-model="newSelectedObj.remarks"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Followed Up</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_follow_ups"
                                                                        item-value="name"
                                                                        v-model="newSelectedObj.followed_up"
                                                                        item-text="name"
                                                                        single-line
                                                                        
                                                                        label="Follow Up"
                                                                        v-on:change="selectedNewFollowedUp"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row wrap mt-3 mb-5></v-layout>
                                                        </v-card>
                                                        <v-btn
                                                            color="primary"
                                                            @click="nextStep(2)"
                                                        >
                                                            Continue
                                                        </v-btn>
                                                        <v-btn text>Cancel</v-btn>
                                                    </v-stepper-content>

                                                    <!-- Page 3  -->
                                                    <v-stepper-content step="3" >
                                                        <v-card
                                                            class="mb-12"
                                                            color="white"
                                                        >
                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <div class="sectionHeader">
                                                                        <span>Defects</span>
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mb-3> 
                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchNewFile4Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(newSelectedObj.pic_4)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="newfile4"
                                                                            
                                                                            v-on:change="onNewFile4Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchNewFile5Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(newSelectedObj.pic_5)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="newfile5"
                                                                            
                                                                            v-on:change="onNewFile5Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchNewFile6Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(newSelectedObj.pic_6)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="newfile6"
                                                                            
                                                                            v-on:change="onNewFile6Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Remarks"
                                                                        
                                                                        v-model="newSelectedObj.remarks_2"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Followed Up</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_follow_ups"
                                                                        item-value="name"
                                                                        v-model="newSelectedObj.followed_up_2"
                                                                        item-text="name"
                                                                        single-line
                                                                        
                                                                        label="Follow Up"
                                                                        v-on:change="selectedNewFollowedUp2"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row wrap mt-3 mb-5></v-layout>
                                                            <v-btn
                                                                color="primary"
                                                                @click="openViewDialog = false"
                                                            >
                                                                Close
                                                            </v-btn>
                                                        </v-card>
                                                    </v-stepper-content>
                                                </v-stepper-items>
                                            </v-stepper>


                                        </v-flex>
                                    </v-card-text>
                                </v-card-text>
                          </v-card>
                        </v-dialog>
                    </v-layout>

                    <!-- edit dialog -->
                    <v-layout row justify-center>
                        <v-dialog v-model="openEditDialog"
                            fullscreen hide-overlay
                            transition="dialog-bottom-transition">

                            <v-card>
                                <v-toolbar dark color="teal" fixed>
                                    <v-btn icon dark
                                        @click="openEditDialog = false">
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>
                                        <span class="white--text title">
                                            Edit Engineer Report and Checklist
                                        </span>
                                    </v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn
                                            dark flat @click="editResourceAction">
                                            Save &amp; Submit
                                        </v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>
                                <v-card-text>
                                    <v-card-text class="white">
                                        <v-flex xs12 sm12 md12 style="margin-top: 5%; padding-left: 10px; padding-right: 10px;">
                                            <v-stepper
                                                v-model="e1"
                                                :vertical="vertical"
                                                :alt-labels="altLabels"
                                            >
                                                <v-stepper-header>
                                                    <template v-for="n in steps">
                                                        <v-stepper-step
                                                            :key="`${n}-step`"
                                                            :complete="e1 > n"
                                                            :step="n"
                                                            :editable="editable"
                                                        >
                                                            Page {{ n }}
                                                        </v-stepper-step>

                                                        <v-divider
                                                        v-if="n !== steps"
                                                        :key="n"
                                                        ></v-divider>
                                                    </template>
                                                </v-stepper-header>

                                                <v-stepper-items>

                                                    <!-- Page 1  -->
                                                    <v-stepper-content step="1" >
                                                        <v-card
                                                            class="mb-12"
                                                            color="white"
                                                        >
                                                            <v-layout row wrap>
                                                                <v-flex xs12 md5>
                                                                    <!-- submit date  -->
                                                                    <v-layout row wrap>
                                                                        <v-flex md3 xs12>
                                                                            <v-subheader class="subTitle">Date</v-subheader>
                                                                        </v-flex>
                                                                        <v-flex md9 xs12>
                                                                            <v-menu
                                                                                v-model="editSubmitDateMenu"
                                                                                :close-on-content-click="false"
                                                                                full-width max-width="290"
                                                                            >
                                                                                <v-text-field
                                                                                    slot="activator"
                                                                                    :value="computedEditSubmitDate"
                                                                                    clearable
                                                                                    label="Date"
                                                                                    prepend-icon="calendar_today"
                                                                                    readonly
                                                                                    
                                                                                >
                                                                                </v-text-field>
                                                                                <v-date-picker
                                                                                    v-model="selectedObj.date"
                                                                                    @change="editSubmitDateMenu = false"
                                                                                    >
                                                                                </v-date-picker>
                                                                            </v-menu>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>

                                                                <v-flex xs12 md1></v-flex>

                                                                <v-flex xs12 md5>
                                                                    <!-- Station -->
                                                                    <v-layout row wrap>
                                                                        <v-flex md4 xs12>
                                                                            <v-subheader class="subTitle">Station</v-subheader>
                                                                        </v-flex>
                                                                        <v-flex md8 xs12>
                                                                            <v-select
                                                                                :items="allStations"
                                                                                item-value="id"
                                                                                v-model="selectedObj.station_id"
                                                                                item-text="station_name"
                                                                                single-line
                                                                                label="Stations"
                                                                                persistent-hint
                                                                                hint="Select Station"
                                                                                
                                                                                v-on:change="selectedStationID"
                                                                            >
                                                                                <template slot="selection" slot-scope="data">
                                                                                        {{ data.item.station_no }} - {{ data.item.station_name }}
                                                                                </template>
                                                                                <template slot="item" slot-scope="data">
                                                                                    {{ data.item.station_no }} - {{ data.item.station_name }}
                                                                                </template>
                                                                            </v-select>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>    
                                                            </v-layout>

                                                            <v-layout row wrap md5>
                                                                <v-flex xs12 md5>
                                                                    <!-- submit time  -->
                                                                    <v-layout row wrap>
                                                                        <v-flex md3 xs12>
                                                                            <v-subheader class="subTitle">Time</v-subheader>
                                                                        </v-flex>
                                                                        <v-flex md9 xs12>
                                                                            <v-dialog
                                                                                ref="editTime"
                                                                                v-model="editTimeDialog"
                                                                                :return-value.sync="selectedObj.time"
                                                                                persistent lazy full-width width="290px"
                                                                            >
                                                                                <v-text-field
                                                                                    
                                                                                    slot="activator" v-model="selectedObj.time"
                                                                                    label="Time" prepend-icon="access_time" readonly
                                                                                ></v-text-field>
                                                                                <v-time-picker v-if="editTimeDialog"
                                                                                v-model="selectedObj.time"
                                                                                full-width
                                                                                >
                                                                                <v-spacer></v-spacer>
                                                                                    <v-btn flat color="primary" @click="editTimeDialog = false">Cancel</v-btn>
                                                                                    <v-btn flat color="primary" @click="editTimeDialog = false">OK</v-btn>
                                                                                </v-time-picker>
                                                                            </v-dialog>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>

                                                                <v-flex xs12 md1></v-flex>

                                                                <v-flex xs12 md5>
                                                                    <!-- Engineer -->
                                                                    <v-layout row wrap>
                                                                        <v-flex md4 xs12>
                                                                            <v-subheader class="subTitle">Engineer</v-subheader>
                                                                        </v-flex>
                                                                        <v-flex md8 xs12>
                                                                            <v-text-field
                                                                                type="text"
                                                                                
                                                                                v-model="currentAuthUser.full_name">
                                                                            </v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>    
                                                            </v-layout>

                                                            <v-layout row wrap mb-3 mt-5>
                                                                <v-flex xs12>
                                                                    <div class="sectionHeader">
                                                                        <span>AUTO TUBE CLEANING SYSTEM PREVENTIVE MAINTENANCE</span>
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Please Select</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_of_atcs"
                                                                        item-value="name"
                                                                        v-model="selectedObj.pm_type"
                                                                        item-text="name"
                                                                        single-line
                                                                        
                                                                        label="Follow Up"
                                                                        v-on:change="selectedTypeOfPm"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row wrap mt-3 mb-5></v-layout>

                                                            <!-- horizontal green line  -->
                                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                                <v-flex xs12>
                                                                    <hr style="border: 1px solid green;" />
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Comments"
                                                                        
                                                                        v-model="selectedObj.comments"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-card>

                                                        <v-btn
                                                            color="primary"
                                                            @click="nextStep(1)"
                                                        >
                                                            Continue
                                                        </v-btn>
                                                        <v-btn text>Cancel</v-btn>
                                                    </v-stepper-content>

                                                    <!-- Page 2  -->
                                                    <v-stepper-content step="2" >
                                                        <v-card
                                                            class="mb-12"
                                                            color="white"
                                                        >
                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <div class="sectionHeader">
                                                                        <span>Selected: {{ selectedObj.pm_type }}</span>
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                             <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <div class="sectionHeader">
                                                                        <span>Replace Sponge Balls</span>
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <span style="font-style: italic;"><strong>*Replace old sponge balls with new sponge balls</strong></span>
                                                                </v-flex>  
                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile1Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_1)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file1"
                                                                            
                                                                            v-on:change="onFile1Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile2Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_2)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file2"
                                                                            
                                                                            v-on:change="onFile2Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile3Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_3)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file3"
                                                                            
                                                                            v-on:change="onFile3Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3>
                                                                <v-flex xs5>
                                                                    <v-subheader class="subTitle">
                                                                       <h4><strong>Number of old sponge balls removed</strong></h4>
                                                                    </v-subheader>
                                                                </v-flex>
                                                                <v-flex xs2></v-flex>
                                                                <v-flex xs5>
                                                                    <v-subheader class="subTitle">
                                                                       <h4><strong>Number of new sponge balls put in</strong></h4>
                                                                    </v-subheader>
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-text-field
                                                                        
                                                                        type="number"
                                                                        v-model="selectedObj.num_of_old_sponge"
                                                                    >
                                                                    </v-text-field>
                                                                </v-flex>
                                                                <v-flex xs2></v-flex>
                                                                <v-flex xs5>
                                                                    <v-text-field
                                                                        
                                                                        type="number"
                                                                        v-model="selectedObj.num_of_new_sponge"
                                                                    >
                                                                    </v-text-field>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Remarks"
                                                                        
                                                                        v-model="selectedObj.remarks"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Followed Up</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_follow_ups"
                                                                        item-value="name"
                                                                        v-model="selectedObj.followed_up"
                                                                        item-text="name"
                                                                        single-line
                                                                        
                                                                        label="Follow Up"
                                                                        v-on:change="selectedFollowedUp"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>

                                                            <!-- horizontal green line  -->
                                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                                <v-flex xs12>
                                                                    <hr style="border: 1px solid green;" />
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <span style="font-style: italic;">
                                                                        *Test <strong>SEND</strong> Mode
                                                                    </span>
                                                                </v-flex>  
                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile4Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_4)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file4"
                                                                            
                                                                            v-on:change="onFile4Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile5Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_5)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file5"
                                                                            
                                                                            v-on:change="onFile5Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile6Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_6)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file6"
                                                                            
                                                                            v-on:change="onFile6Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3>
                                                                <v-flex xs12>
                                                                    <v-subheader class="subTitle">
                                                                       <h4><strong>Status : {{ selectedObj.status }}</strong></h4>
                                                                    </v-subheader>
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        
                                                                        style="width: 100%;"
                                                                        :color="selectedObj.status != null ? (selectedObj.status == 'done' ? 'green' : '#ccc') : '#ccc'"
                                                                        @click="toggleStatus('done')"
                                                                    >
                                                                        <v-icon :color="selectedObj.status != null ? (selectedObj.status == 'done' ? 'white' : '#000') : '#000'">checked</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                                <v-flex xs2></v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        
                                                                        style="width: 100%;"
                                                                        :color="selectedObj.status != null ? (selectedObj.status == 'fail' ? 'red' : '#ccc') : '#ccc'"
                                                                        @click="toggleStatus('fail')"
                                                                    >
                                                                        <v-icon :color="selectedObj.status != null ? (selectedObj.status == 'fail' ? 'white' : '#000') : '#000'">close</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Remarks"
                                                                        
                                                                        v-model="selectedObj.remarks_2"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Followed Up</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_follow_ups"
                                                                        item-value="name"
                                                                        v-model="selectedObj.followed_up_2"
                                                                        item-text="name"
                                                                        single-line
                                                                        
                                                                        label="Follow Up"
                                                                        v-on:change="selectedFollowedUp2"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>

                                                            <!-- horizontal green line  -->
                                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                                <v-flex xs12>
                                                                    <hr style="border: 1px solid green;" />
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <span style="font-style: italic;">
                                                                        *Test <strong>RETURN</strong> Mode
                                                                    </span>
                                                                </v-flex>  
                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile7Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_7)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file7"
                                                                            
                                                                            v-on:change="onFile7Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile8Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_8)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file8"
                                                                            
                                                                            v-on:change="onFile8Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile9Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_9)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file9"
                                                                            
                                                                            v-on:change="onFile9Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3>
                                                                <v-flex xs12>
                                                                    <v-subheader class="subTitle">
                                                                       <h4><strong>Status : {{ selectedObj.status_2 }}</strong></h4>
                                                                    </v-subheader>
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        
                                                                        style="width: 100%;"
                                                                        :color="selectedObj.status_2 != null ? (selectedObj.status_2 == 'done' ? 'green' : '#ccc') : '#ccc'"
                                                                        @click="toggleStatus2('done')"
                                                                    >
                                                                        <v-icon :color="selectedObj.status_2 != null ? (selectedObj.status_2 == 'done' ? 'white' : '#000') : '#000'">checked</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                                <v-flex xs2></v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        
                                                                        style="width: 100%;"
                                                                        :color="selectedObj.status_2 != null ? (selectedObj.status_2 == 'fail' ? 'red' : '#ccc') : '#ccc'"
                                                                        @click="toggleStatus2('fail')"
                                                                    >
                                                                        <v-icon :color="selectedObj.status_2 != null ? (selectedObj.status_2 == 'fail' ? 'white' : '#000') : '#000'">close</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Remarks"
                                                                        
                                                                        v-model="selectedObj.remarks_3"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Followed Up</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_follow_ups"
                                                                        item-value="name"
                                                                        v-model="selectedObj.followed_up_3"
                                                                        item-text="name"
                                                                        single-line
                                                                        
                                                                        label="Follow Up"
                                                                        v-on:change="selectedFollowedUp3"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>

                                                            <!-- horizontal green line  -->
                                                            <v-layout row wrap style="margin-top: 80px;margin-bottom: 80px;">
                                                                <v-flex xs12>
                                                                    <hr style="border: 1px solid green;" />
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <span style="font-style: italic;">
                                                                        *Test <strong>REST</strong> Mode
                                                                    </span>
                                                                </v-flex>  
                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile7Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_10)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file10"
                                                                            
                                                                            v-on:change="onFile10Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile11Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_11)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file11"
                                                                            
                                                                            v-on:change="onFile11Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile12Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_12)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file12"
                                                                            
                                                                            v-on:change="onFile12Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3>
                                                                <v-flex xs12>
                                                                    <v-subheader class="subTitle">
                                                                       <h4><strong>Status : {{ selectedObj.status_3 }}</strong></h4>
                                                                    </v-subheader>
                                                                </v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        
                                                                        style="width: 100%;"
                                                                        :color="selectedObj.status_3 != null ? (selectedObj.status_3 == 'done' ? 'green' : '#ccc') : '#ccc'"
                                                                        @click="toggleStatus3('done')"
                                                                    >
                                                                        <v-icon :color="selectedObj.status_3 != null ? (selectedObj.status_3 == 'done' ? 'white' : '#000') : '#000'">checked</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                                <v-flex xs2></v-flex>
                                                                <v-flex xs5>
                                                                    <v-btn
                                                                        
                                                                        style="width: 100%;"
                                                                        :color="selectedObj.status_3 != null ? (selectedObj.status_3 == 'fail' ? 'red' : '#ccc') : '#ccc'"
                                                                        @click="toggleStatus3('fail')"
                                                                    >
                                                                        <v-icon :color="selectedObj.status_3 != null ? (selectedObj.status_3 == 'fail' ? 'white' : '#000') : '#000'">close</v-icon>
                                                                    </v-btn>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Remarks"
                                                                        
                                                                        v-model="selectedObj.remarks_4"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Followed Up</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_follow_ups"
                                                                        item-value="name"
                                                                        v-model="selectedObj.followed_up_4"
                                                                        item-text="name"
                                                                        single-line
                                                                        
                                                                        label="Follow Up"
                                                                        v-on:change="selectedFollowedUp4"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5></v-layout>
                                                        </v-card>
                                                        <v-btn
                                                            color="primary"
                                                            @click="nextStep(2)"
                                                        >
                                                            Continue
                                                        </v-btn>
                                                        <v-btn text>Cancel</v-btn>
                                                    </v-stepper-content>

                                                    <!-- Page 3  -->
                                                    <v-stepper-content step="3" >
                                                        <v-card
                                                            class="mb-12"
                                                            color="white"
                                                        >
                                                            <v-layout row wrap mb-3>
                                                                <v-flex xs12>
                                                                    <div class="sectionHeader">
                                                                        <span>Defects</span>
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mb-3> 
                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile13Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_13)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file13"
                                                                            
                                                                            v-on:change="onFile13Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile14Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_14)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file14"
                                                                            
                                                                            v-on:change="onFile14Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>

                                                                <v-flex md4 xs12>
                                                                    <div class="addPhotoTitle">
                                                                        <span><strong>Add Photo</strong></span>
                                                                    </div>
                                                                    <div class="imgContainer">
                                                                        <a href="javascript:void(0)" v-on:click="launchFile15Picker">
                                                                            <v-img
                                                                                class="imgF"
                                                                                :src="getFeatureImages(selectedObj.pic_15)"
                                                                            >
                                                                            </v-img>
                                                                        </a>
                                                                        <input type="file"
                                                                            ref="file15"
                                                                            
                                                                            v-on:change="onFile15Change"
                                                                            style="display:none">
                                                                    </div>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout mt-3>
                                                                <v-flex xs12>
                                                                    <v-textarea
                                                                        box
                                                                        type="text"
                                                                        label="Remarks"
                                                                        
                                                                        v-model="selectedObj.remarks_5"
                                                                    ></v-textarea>
                                                                </v-flex>
                                                            </v-layout>

                                                            <v-layout row wrap mt-3 mb-5>
                                                                <v-flex md4 xs12>
                                                                    <v-subheader class="subTitle">Followed Up</v-subheader>
                                                                </v-flex>
                                                                <v-flex md8 xs12>
                                                                    <v-select
                                                                        :items="type_follow_ups"
                                                                        item-value="name"
                                                                        v-model="selectedObj.followed_up_5"
                                                                        item-text="name"
                                                                        single-line
                                                                        
                                                                        label="Follow Up"
                                                                        v-on:change="selectedFollowedUp5"
                                                                    >
                                                                        <template slot="selection" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                        <template slot="item" slot-scope="data">
                                                                            {{ data.item.name }}
                                                                        </template>
                                                                    </v-select>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row wrap mt-3 mb-5></v-layout>
                                                            <v-btn
                                                                color="primary"
                                                                @click="openViewDialog = false"
                                                            >
                                                                Close
                                                            </v-btn>
                                                        </v-card>
                                                    </v-stepper-content>
                                                </v-stepper-items>
                                            </v-stepper>


                                        </v-flex>
                                    </v-card-text>
                                </v-card-text>
                          </v-card>
                        </v-dialog>
                    </v-layout>

                    <!-- delete dialog  -->
                    <v-layout row justify-center>
                        <v-dialog v-model="openDeleteDialog" persistent max-width="550">

                            <v-card>
                                <v-card-title class="title red white--text">Confirm Delete Report - {{ selectedObj.checklist_no }} ?</v-card-title>
                                <v-card-text>
                                    Please make sure you know what you are doing as this action is undone.
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="grey darken-1" flat @click="openDeleteDialog = false">Cancel</v-btn>
                                    <v-btn color="red darken-1" flat @click="deleteResourceAction(selectedObj.id)">Delete</v-btn>
                                </v-card-actions>
                            </v-card>
                       </v-dialog>
                    </v-layout>

                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import moment from 'moment'
    import {
        // eslint-disable-next-line
        ACTION_STATION_GET_ALL_STATIONS,
        // eslint-disable-next-line
        GETTERS_STATION_GET_ALL_STATIONS,
    } from '../../../../../../../../utils/constants/modules/Stations/AllStationModules';
    import {
        // eslint-disable-next-line
        ACTION_STATION_GET_ALL_EQUIEMENT_TYPES,
        // eslint-disable-next-line
        GETTERS_STATION_GET_ALL_EQUIEMENT_TYPES,
    } from '../../../../../../../../utils/constants/modules/Stations/AllStationModules';
    import {
        // eslint-disable-next-line
        ACTION_CK_EM_ATC_GET_ALL_ATCS,
        // eslint-disable-next-line
        GETTERS_CK_EM_ATC_GET_ALL_ATCS,
        // eslint-disable-next-line
        ACTION_CK_EM_ATC_ADD_NEW_ATC,
        // eslint-disable-next-line
        ACTION_CK_EM_ATC_UPDATE_ATC,
        // eslint-disable-next-line
        ACTION_CK_EM_ATC_DELETE_ATC,
    } from '../../../../../../../../utils/constants/modules/CheckLists/AllCheckListsModules'

    import {
        GETTERS_USER_GROUPS_GET_AUTH_USER
    } from '../../../../../../../../utils/constants/modules/UserGroups/Users/UserModules';

    import { PaginationCollections } from '../../../../../../../../utils/mixins';

    import {
        ACTION_SET_LOADING_A
    } from '../../../../../../../../utils/constants/modules/Status/LoadingStatus/LoadingStatusModules';

    import VuePagination from '../../../../../../../../components/paginations/VuePagination.vue';
    import VueHtml2pdf from 'vue-html2pdf'
    
    export default {
        mixins: [
            PaginationCollections
        ],
        props:{
        },
        created: function () {

            let userRoleID = window.localStorage.getItem('current_user_role');

            this.currentUserRoleID = userRoleID

             let station_payload = {
                per_page: this.option_num,
                page_id: 1
            }

            this.$store.dispatch(ACTION_STATION_GET_ALL_STATIONS, station_payload)
            this.$store.dispatch(ACTION_STATION_GET_ALL_EQUIEMENT_TYPES, station_payload)
            let payload = {
                per_page: this.per_page_num,
                page_id: 1,
            }

            this.$store.dispatch(ACTION_CK_EM_ATC_GET_ALL_ATCS, payload)

            // bulk edit
            if (this.currentUserRoleID == 4) {
                this.showBulkSignButton = true;
            }

        },
        data: function () {
            return {
                feature_img: require("../../../../../../../../assets/images/features/default.png"),
                logo: require("../../../../../../../../assets/images/logo/sbs_transit.png"),
                per_page_num: 20,
                // option_num: 99999,
                option_num: 100,
                search: null,
                expandedModel: [true],

                e1: 1,
                steps: 3,
                vertical: false,
                altLabels: false,
                editable: true,
                type_follow_ups: [
                    {
                        'id': 1,
                        'name': 'Water Cooled Chiller (WCC) - Modustack'
                    },
                    {
                        'id': 2,
                        'name': 'Chemical Pot Feeder (ATC) – Kurita '
                    },
                    {
                        'id': 3,
                        'name': 'Compress Air System (ATC) – Air Power'
                    },
                    {
                        'id': 4,
                        'name': 'Auto Tube Cleaning (ATC) System – Hydroball'
                    },
                    {
                        'id': 5,
                        'name': 'Electrical Panels – OSS'
                    },
                    {
                        'id': 6,
                        'name': 'Non-Chemical Treatment Plant (NCP) – MEDEC'
                    },
                    {
                        'id': 7,
                        'name': 'Local Sequential Controllers (LSC) – ABME (Liu-Tay)'
                    },
                ],

                type_of_atcs: [
                    {
                        'id': 1,
                        'name': 'ATC - 01'
                    },
                    {
                        'id': 2,
                        'name': 'ATC - 02'
                    },
                    {
                        'id': 3,
                        'name': 'ATC - 03'
                    },
                ],

                type_of_maintenance: [
                    {
                        'id': 1,
                        'name': 'Monthly - Fill Up Item 1 to 8 only'
                    },
                    {
                        'id': 2,
                        'name': 'Quartery - Fill Up Item 1 to 9 only'
                    },
                    {
                        'id': 3,
                        'name': 'Half Yearly - Fill Up Item 1 to 11 only'
                    },
                    {
                        'id': 4,
                        'name': 'Annually - Fill Up Item 1 to 19 only'
                    },
                ],
                fvs: {
                    headers: [
                        {
                            text: 'No',
                            align: 'left',
                            sortable: false,
                        },
                        { text: 'CheckList No', value: 'checklist_no', sortable: false, },
                        { text: 'Date', value: 'system',sortable: false, },
                        { text: 'Time', value: 'system', sortable: false, },
                        { text: 'View', value: '' ,sortable: false, },
                        { text: 'Edit', value: '' ,sortable: false, },
                        { text: 'Download', value: '' ,sortable: false, },
                        { text: 'Delete', value: '' ,sortable: false, },
                    ],
                },

                user_id: null,

                // Bulk Edit
                selected: [],
                selectedFormID: [],
                checklist_format_id: 26,
                showBulkSignButton: false,

                // LIST DATA TABLE
                openViewDialog: false,
                openAddDialog: false,
                openEditDialog: false,
                openDeleteDialog: false,
                selectedObj: {
                    checklist_no: null,
                    ck_form_id: null,
                    date: null,
                    time: null,
                    station_id: null,

                    comments: 'All ATC Systems are running in normal working conditions.  ',
                    selectedImgFile1: null,
                    pic_1: null,
                    selectedImgFile2: null,
                    pic_2: null,
                    selectedImgFile3: null,
                    pic_3: null,
                    selectedImgFile4: null,
                    pic_4: null,
                    selectedImgFile5: null,
                    pic_5: null,
                    selectedImgFile6: null,
                    pic_6: null,
                    selectedImgFile7: null,
                    pic_7: null,
                    selectedImgFile8: null,
                    pic_8: null,
                    selectedImgFile9: null,
                    pic_9: null,
                    selectedImgFile10: null,
                    pic_10: null,
                    selectedImgFile11: null,
                    pic_11: null,
                    selectedImgFile12: null,
                    pic_12: null,
                    selectedImgFile13: null,
                    pic_13: null,
                    selectedImgFile14: null,
                    pic_14: null,
                    selectedImgFile15: null,
                    pic_15: null,

                    status: null,
                    status_2: null,
                    status_3: null,
                    
                    remarks: null,
                    remarks_2: null,
                    remarks_3: null,
                    remarks_4: null,
                    remarks_5: null,

                    followed_up: null,
                    followed_up_2: null,
                    followed_up_3: null,
                    followed_up_4: null,
                    followed_up_5: null,

                    atcs_type: null,

                    num_of_old_sponge: null,
                    num_of_new_sponge: null,

                    created_by: null
                },

                // new
                newSelectedObj: {
                    checklist_no: null,
                    ck_form_id: null,
                    date: null,
                    time: null,
                    station_id: null,

                    comments: 'All ATC Systems are running in normal working conditions.  ',
                    selectedImgFile1: null,
                    pic_1: null,
                    selectedImgFile2: null,
                    pic_2: null,
                    selectedImgFile3: null,
                    pic_3: null,
                    selectedImgFile4: null,
                    pic_4: null,
                    selectedImgFile5: null,
                    pic_5: null,
                    selectedImgFile6: null,
                    pic_6: null,
                    selectedImgFile7: null,
                    pic_7: null,
                    selectedImgFile8: null,
                    pic_8: null,
                    selectedImgFile9: null,
                    pic_9: null,
                    selectedImgFile10: null,
                    pic_10: null,
                    selectedImgFile11: null,
                    pic_11: null,
                    selectedImgFile12: null,
                    pic_12: null,
                    selectedImgFile13: null,
                    pic_13: null,
                    selectedImgFile14: null,
                    pic_14: null,
                    selectedImgFile15: null,
                    pic_15: null,

                    status: null,
                    status_2: null,
                    status_3: null,
                    
                    remarks: null,
                    remarks_2: null,
                    remarks_3: null,
                    remarks_4: null,
                    remarks_5: null,

                    followed_up: null,
                    followed_up_2: null,
                    followed_up_3: null,
                    followed_up_4: null,
                    followed_up_5: null,

                    atcs_type: null,

                    num_of_old_sponge: null,
                    num_of_new_sponge: null,

                    created_by: null
                },

                newSubmitDateMenu: false,
                newVisitingDateMenu: false,
                newSign1DateMenu: false,
                newSign2DateMenu: false,
                newSign3DateMenu: false,
                newTimeDialog: false,

                editSubmitDateMenu: false,
                editVisitingDateMenu: false,
                editSign1DateMenu: false,
                editSign2DateMenu: false,
                editSign3DateMenu: false,
                editTimeDialog: false,

                openNewSignPad1: false,
                openNewSignPad2: false,

                openSignPad1: false,
                openSignPad2: false,
            };
        },
        computed: {
            pagination_collections () {
                return this.$store.getters.GETTER_PAGINATION_GET_LISTS
            },
            current_page_id () {
                return this.collection.currentPage
            },
            per_page () {
                return this.collection.perPage
            },
            items() {
                let vm = this
                let result = this.$store.getters.GETTERS_CK_EM_ATC_GET_ALL_ATCS
                var array = Object.keys(result).map(item => result[item]);

                return array
            },
            allStations() {
                let vm = this
                let result = this.$store.getters.GETTERS_STATION_GET_ALL_STATIONS
                var array = Object.keys(result).map(item => result[item]);

                return array
            },
            allEquiements() {
                let vm = this
                let result = this.$store.getters.GETTERS_STATION_GET_ALL_EQUIEMENT_TYPES
                var array = Object.keys(result).map(item => result[item]);

                return array
            },
            currentAuthUser() {
                let authUser = this.$store.getters.GETTERS_USER_GROUPS_GET_AUTH_USER

                if (this.currentUserRoleID == 1) {
                    this.user_id = authUser.user_group_id
                }
                else {
                    this.user_id = authUser.user_group_id
                }

                console.log(authUser);
                

                return authUser
            },
            computedNewSubmitDate() {
                return this.newSelectedObj.date ?
                    moment(this.newSelectedObj.date).format('YYYY-MM-DD') : ''
            },
            
            computedEditSubmitDate() {
                return this.selectedObj.date ?
                    moment(this.selectedObj.date).format('YYYY-MM-DD') : ''
            },
        },
        watch: {
            pagination_collections: function(value) {
                let defaultCollection = {
                    action: ACTION_CK_EM_ATC_GET_ALL_ATCS,
                    sort: 'desc',
                    order_by: 'id',
                    per_page: value['meta']['per_page'],
                    current_page: value['meta']['current_page'],
                    last_page: value['meta']['last_page'],
                    total: value['meta']['total'],
                    from: value['meta']['from'],
                    to: value['meta']['to'],
                    data: value['data'],
                    payload: {
                        per_page: this.per_page,
                        page_id: this.current_page_id,
                    }
                }

                this.collection.setState(defaultCollection)
            },
            user_id: function (user_id) {
                this.user_id = user_id

                if (this.currentUserRoleID != 1) {
                    let payload = {
                        per_page: this.per_page,
                        page_id: this.current_page_id,
                        user_id: this.user_id
                    }
                    this.$store.dispatch(ACTION_REPORT_GET_ALL_FIELD_VISIT_SERVICES, payload)
                }
            },
            steps (val) {
                if (this.e1 > val) {
                this.e1 = val
                }
            },
            vertical () {
                this.e1 = 2
                requestAnimationFrame(() => this.e1 = 1) // Workarounds
            },

        },
        methods: {
            nextStep (n) {
                if (n === this.steps) {
                this.e1 = 1
                } else {
                this.e1 = n + 1
                }
            },
            getFeatureImages: function (icon_url) {
                if (icon_url != null) {
                    return icon_url
                }
                else {
                    return this.feature_img
                }
            },
            
            selectedNewStationID: function ($event) {
                // console.log(`selected Station ID :${$event}`);
                this.newSelectedObj.station_id = $event
            },
            selectedStationID: function ($event) {
                console.log(`selected Station ID :${$event}`);
                this.selectedObj.station_id = $event
            },
            toggleNewStatus: function (status) {
                this.newSelectedObj.status = status; 
            },
            toggleNewStatus2: function (status) {
                this.newSelectedObj.status_2 = status; 
            },
            toggleNewStatus3: function (status) {
                this.newSelectedObj.status_3 = status; 
            },
            toggleStatus: function (status) {
                this.selectedObj.status = status; 
            },
            toggleStatus2: function (status) {
                this.selectedObj.status_2 = status; 
            },
            toggleStatus3: function (status) {
                this.selectedObj.status_3 = status; 
            },

            // ADJUST HERE
            selectedNewFollowedUp: function ($event) {
                this.newSelectedObj.followed_up = $event
            },
            selectedNewFollowedUp2: function ($event) {
                this.newSelectedObj.followed_up_2 = $event
            },
            selectedNewFollowedUp3: function ($event) {
                this.newSelectedObj.followed_up_3 = $event
            },
            selectedNewFollowedUp4: function ($event) {
                this.newSelectedObj.followed_up_4 = $event
            },
            selectedNewFollowedUp5: function ($event) {
                this.newSelectedObj.followed_up_5 = $event
            },
            selectedFollowedUp: function ($event) {
                this.selectedObj.followed_up = $event
            },
            selectedFollowedUp2: function ($event) {
                this.selectedObj.followed_up_2 = $event
            },
            selectedFollowedUp3: function ($event) {
                this.selectedObj.followed_up_3 = $event
            },
            selectedFollowedUp4: function ($event) {
                this.selectedObj.followed_up_4 = $event
            },
            selectedFollowedUp5: function ($event) {
                this.selectedObj.followed_up_5 = $event
            },

            selectedTypeOfPm: function ($event) {
                this.selectedObj.pm_type = $event
            },
            selectedNewTypeOfPm: function ($event) {
                this.newSelectedObj.pm_type = $event
            },

            // Pic
            launchNewFile1Picker: function (){
                this.$refs.newfile1.click();
            },
            onNewFile1Change: function (event) {
                this.newSelectedObj.selectedImgFile1 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_1 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile1 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile1.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile1 );
                    }
                }
            },
            launchNewFile2Picker: function (){
                this.$refs.newfile2.click();
            },
            onNewFile2Change: function (event) {
                this.newSelectedObj.selectedImgFile2 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_2 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile2 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile2.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile2 );
                    }
                }
            },
            launchNewFile3Picker: function (){
                this.$refs.newfile3.click();
            },
            onNewFile3Change: function (event) {
                this.newSelectedObj.selectedImgFile3 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_3 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile3 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile3.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile3 );
                    }
                }
            },
            launchNewFile4Picker: function (){
                this.$refs.newfile4.click();
            },
            onNewFile4Change: function (event) {
                this.newSelectedObj.selectedImgFile4 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_4 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile4 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile4.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile4 );
                    }
                }
            },
            launchNewFile5Picker: function (){
                this.$refs.newfile5.click();
            },
            onNewFile5Change: function (event) {
                this.newSelectedObj.selectedImgFile5 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_5 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile5 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile5.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile5 );
                    }
                }
            },
            launchNewFile6Picker: function (){
                this.$refs.newfile6.click();
            },
            onNewFile6Change: function (event) {
                this.newSelectedObj.selectedImgFile6 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_6 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile6 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile6.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile6 );
                    }
                }
            },
            launchNewFile7Picker: function (){
                this.$refs.newfile7.click();
            },
            onNewFile7Change: function (event) {
                this.newSelectedObj.selectedImgFile7 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_7 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile7 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile7.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile7 );
                    }
                }
            },
            launchNewFile8Picker: function (){
                this.$refs.newfile6.click();
            },
            onNewFile8Change: function (event) {
                this.newSelectedObj.selectedImgFile8 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_8 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile8 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile8.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile8 );
                    }
                }
            },
            launchNewFile9Picker: function (){
                this.$refs.newfile9.click();
            },
            onNewFile9Change: function (event) {
                this.newSelectedObj.selectedImgFile9 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_9 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile9 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile9.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile9 );
                    }
                }
            },
            launchNewFile10Picker: function (){
                this.$refs.newfile10.click();
            },
            onNewFile10Change: function (event) {
                this.newSelectedObj.selectedImgFile10 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_10 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile10 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile10.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile10 );
                    }
                }
            },
            launchNewFile11Picker: function (){
                this.$refs.newfile11.click();
            },
            onNewFile11Change: function (event) {
                this.newSelectedObj.selectedImgFile11 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_11 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile11 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile11.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile11 );
                    }
                }
            },
            launchNewFile12Picker: function (){
                this.$refs.newfile12.click();
            },
            onNewFile12Change: function (event) {
                this.newSelectedObj.selectedImgFile12 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_12 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile12 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile12.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile12 );
                    }
                }
            },
            launchNewFile13Picker: function (){
                this.$refs.newfile13.click();
            },
            onNewFile13Change: function (event) {
                this.newSelectedObj.selectedImgFile13 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_13 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile13 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile13.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile13 );
                    }
                }
            },
            launchNewFile14Picker: function (){
                this.$refs.newfile14.click();
            },
            onNewFile14Change: function (event) {
                this.newSelectedObj.selectedImgFile14 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_14 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile14 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile14.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile14 );
                    }
                }
            },
            launchNewFile15Picker: function (){
                this.$refs.newfile15.click();
            },
            onNewFile15Change: function (event) {
                this.newSelectedObj.selectedImgFile15 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.newSelectedObj.pic_15 = reader.result;
                }.bind(this), false);

                if( this.newSelectedObj.selectedImgFile15 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.newSelectedObj.selectedImgFile15.name ) ) {
                        reader.readAsDataURL( this.newSelectedObj.selectedImgFile15 );
                    }
                }
            },

            launchFile1Picker: function (){
                this.$refs.file1.click();
            },
            onFile1Change: function (event) {
                this.selectedObj.selectedImgFile1 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_1 = reader.result;
                }.bind(this), false);

                if( this.sSelectedObj.selectedImgFile1 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile1.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile1 );
                    }
                }
            },
            launchFile2Picker: function (){
                this.$refs.file2.click();
            },
            onFile2Change: function (event) {
                this.selectedObj.selectedImgFile2 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_2 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile2 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile2.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile2 );
                    }
                }
            },
            launchFile3Picker: function (){
                this.$refs.file3.click();
            },
            onFile3Change: function (event) {
                this.selectedObj.selectedImgFile3 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_3 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile3 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile3.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile3 );
                    }
                }
            },
            launchFile4Picker: function (){
                this.$refs.file4.click();
            },
            onFile4Change: function (event) {
                this.selectedObj.selectedImgFile4 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_4 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile4 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile4.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile4 );
                    }
                }
            },
            launchFile5Picker: function (){
                this.$refs.file5.click();
            },
            onFile5Change: function (event) {
                this.selectedObj.selectedImgFile5 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_5 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile5 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile5.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile5 );
                    }
                }
            },
            launchFile6Picker: function (){
                this.$refs.file6.click();
            },
            onFile6Change: function (event) {
                this.selectedObj.selectedImgFile6 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_6 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile6 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile6.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile6 );
                    }
                }
            },
            launchFile7Picker: function (){
                this.$refs.file7.click();
            },
            onFile7Change: function (event) {
                this.selectedObj.selectedImgFile7 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_7 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile7 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile7.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile7 );
                    }
                }
            },
            launchFile8Picker: function (){
                this.$refs.file8.click();
            },
            onFile8Change: function (event) {
                this.selectedObj.selectedImgFile8 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_8 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile8 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile8.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile8 );
                    }
                }
            },
            launchFile9Picker: function (){
                this.$refs.file9.click();
            },
            onFile9Change: function (event) {
                this.selectedObj.selectedImgFile9 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_9 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile9 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile9.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile9 );
                    }
                }
            },
            launchFile10Picker: function (){
                this.$refs.file10.click();
            },
            onFile10Change: function (event) {
                this.selectedObj.selectedImgFile10 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_10 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile10 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile10.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile10 );
                    }
                }
            },
            launchFile11Picker: function (){
                this.$refs.file11.click();
            },
            onFile11Change: function (event) {
                this.selectedObj.selectedImgFile11 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_11 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile11 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile11.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile11 );
                    }
                }
            },
            launchFile12Picker: function (){
                this.$refs.file12.click();
            },
            onFile12Change: function (event) {
                this.selectedObj.selectedImgFile12 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_12 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile12 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile12.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile12 );
                    }
                }
            },
            launchFile13Picker: function (){
                this.$refs.file13.click();
            },
            onFile13Change: function (event) {
                this.selectedObj.selectedImgFile13 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_13 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile13 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile13.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile13 );
                    }
                }
            },
            launchFile14Picker: function (){
                this.$refs.file14.click();
            },
            onFile14Change: function (event) {
                this.selectedObj.selectedImgFile14 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_14 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile14 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile14.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile14 );
                    }
                }
            },
            launchFile15Picker: function (){
                this.$refs.file15.click();
            },
            onFile15Change: function (event) {
                this.selectedObj.selectedImgFile15 = event.target.files[0]
                let reader  = new FileReader();

                reader.addEventListener("load", function () {
                    this.selectedObj.pic_15 = reader.result;
                }.bind(this), false);

                if( this.selectedObj.selectedImgFile15 ){
                    if ( /\.(jpe?g|png|gif)$/i.test( this.selectedObj.selectedImgFile15.name ) ) {
                        reader.readAsDataURL( this.selectedObj.selectedImgFile15 );
                    }
                }
            },
            

            // MUST
            openViewDialogAction: function (item) {
                this.openViewDialog = true
                item.station_id = parseInt(item.station_id);
                item.equiement_id = parseInt(item.equiement_id);
                this.selectedObj = item
            },
            openAddDialogAction: function () {
                this.openAddDialog = true
                var current_datetime = moment().format("YYYYMMDDHHmmss")
                this.newSelectedObj.checklist_no = `FV${current_datetime}`
                // this.$router.push({ name: 'Create New Fault Call Service', params: { } })
            },
            openEditDialogAction: function (item) {
                this.openEditDialog = true
                item.station_id = parseInt(item.station_id);
                item.equiement_id = parseInt(item.equiement_id);
                this.selectedObj = item
            },
            openDeleteDialogAction: function (item) {
                this.openDeleteDialog = true

                this.selectedObj = item
            },
            
            dataURItoBlob:function (base64Data) {
                var byteString;
                if (base64Data.split(',')[0].indexOf('base64') >= 0)
                byteString = atob(base64Data.split(',')[1]);
                else
                byteString = unescape(base64Data.split(',')[1]);
                var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
                var ia = new Uint8Array(byteString.length);
                for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
                }
                return new Blob([ia], {type:mimeString});
            },
            openNewSign1Action() {
                this.openNewSignPad1 = true
                this.$nextTick(function () {
                    this.$refs.newSignaturePad1.resizeCanvas(this.$refs.newSignaturePad1.$refs.signaturePadCanvas);
                // this.$refs.signaturePad.resizeCanvas() <- WOULD BE EASIER
                });
                    },
            newUndoSign1() {
                this.$refs.newSignaturePad1.undoSignature();
            },
            newSaveSign1() {
                const { isEmpty, data } = this.$refs.newSignaturePad1.saveSignature();
                //console.log(isEmpty);
                //console.log(data);
                this.newSelectedObj.maintained_by_signature = this.dataURItoBlob(data)
                //console.log(this.newSelectedObj.inspectionSignFile);
            },
            openNewSign2Action() {
                this.openNewSignPad2 = true
                this.$nextTick(function () {
                    this.$refs.newSignaturePad2.resizeCanvas(this.$refs.newSignaturePad2.$refs.signaturePadCanvas);
                // this.$refs.signaturePad.resizeCanvas() <- WOULD BE EASIER
                });
                    },
            newUndoSign2() {
                this.$refs.newSignaturePad2.undoSignature();
            },
            newSaveSign2() {
                const { isEmpty, data } = this.$refs.newSignaturePad2.saveSignature();
                //console.log(isEmpty);
                //console.log(data);
                this.newSelectedObj.signed_by_sbst_signature = this.dataURItoBlob(data)
                //console.log(this.newSelectedObj.inspectionSignFile);
            },
            

            openSign1Action() {
                this.openSignPad1 = true
                this.$nextTick(function () {
                    this.$refs.signaturePad1.resizeCanvas(this.$refs.signaturePad1.$refs.signaturePadCanvas);
                // this.$refs.signaturePad.resizeCanvas() <- WOULD BE EASIER
                });
                    },
            undoSign1() {
                this.$refs.signaturePad1.undoSignature();
            },
            saveSign1() {
                const { isEmpty, data } = this.$refs.signaturePad1.saveSignature();
                //console.log(isEmpty);
                console.log(data);
                this.selectedObj.maintained_by_signature = this.dataURItoBlob(data)
                //console.log(this.newSelectedObj.inspectionSignFile);
            },

            openSign2Action() {
                this.openSignPad2 = true
                this.$nextTick(function () {
                    this.$refs.signaturePad2.resizeCanvas(this.$refs.signaturePad2.$refs.signaturePadCanvas);
                // this.$refs.signaturePad.resizeCanvas() <- WOULD BE EASIER
                });
                    },
            undoSign2() {
                this.$refs.signaturePad2.undoSignature();
            },
            saveSign2() {
                const { isEmpty, data } = this.$refs.signaturePad2.saveSignature();
                //console.log(isEmpty);
                console.log(data);
                this.selectedObj.signed_by_sbst_signature = this.dataURItoBlob(data)
                //console.log(this.newSelectedObj.inspectionSignFile);
            },

            // Submit Time
            editTimePicker: function () {
                this.$refs.editTime.save(this.selectedObj.time)
            },
            newTimePicker: function () {
                this.$refs.newTime.save(this.newSelectedObj.time);
            },

            addResourceAction: function () {
                const formData = new FormData();

                if (this.newSelectedObj.checklist_no != null) {
                    formData.append('checklist_no', this.newSelectedObj.checklist_no);
                }

                if (this.newSelectedObj.ck_form_id != null) {
                    formData.append('ck_form_id', this.newSelectedObj.ck_form_id);
                }

                if (this.newSelectedObj.station_id != null) {
                    formData.append('station_id', this.newSelectedObj.station_id);
                }

                if (this.newSelectedObj.date != null) {
                    formData.append('date', this.newSelectedObj.date);
                }

                if (this.newSelectedObj.time != null) {
                    formData.append('time', this.newSelectedObj.time);
                }

                if (this.newSelectedObj.comments != null) {
                    formData.append('comments', this.newSelectedObj.comments);
                }

                if (this.newSelectedObj.selectedImgFile1 != null) {
                    formData.append('pic_1', this.newSelectedObj.selectedImgFile1, 'pic_1.png')
                }

                if (this.newSelectedObj.selectedImgFile2 != null) {
                    formData.append('pic_2', this.newSelectedObj.selectedImgFile2, 'pic_2.png')
                }

                if (this.newSelectedObj.selectedImgFile3 != null) {
                    formData.append('pic_3', this.newSelectedObj.selectedImgFile3, 'pic_3.png')
                }

                if (this.newSelectedObj.selectedImgFile4 != null) {
                    formData.append('pic_4', this.newSelectedObj.selectedImgFile4, 'pic_4.png')
                }

                if (this.newSelectedObj.selectedImgFile5 != null) {
                    formData.append('pic_5', this.newSelectedObj.selectedImgFile5, 'pic_5.png')
                }

                if (this.newSelectedObj.selectedImgFile6 != null) {
                    formData.append('pic_6', this.newSelectedObj.selectedImgFile6, 'pic_6.png')
                }

                if (this.newSelectedObj.selectedImgFile7 != null) {
                    formData.append('pic_7', this.newSelectedObj.selectedImgFile7, 'pic_7.png')
                }

                if (this.newSelectedObj.selectedImgFile8 != null) {
                    formData.append('pic_8', this.newSelectedObj.selectedImgFile8, 'pic_8.png')
                }

                if (this.newSelectedObj.selectedImgFile9 != null) {
                    formData.append('pic_9', this.newSelectedObj.selectedImgFile9, 'pic_9.png')
                }

                if (this.newSelectedObj.selectedImgFile10 != null) {
                    formData.append('pic_10', this.newSelectedObj.selectedImgFile10, 'pic_10.png')
                }

                if (this.newSelectedObj.selectedImgFile11 != null) {
                    formData.append('pic_11', this.newSelectedObj.selectedImgFile11, 'pic_11.png')
                }

                if (this.newSelectedObj.selectedImgFile12 != null) {
                    formData.append('pic_12', this.newSelectedObj.selectedImgFile12, 'pic_12.png')
                }

                if (this.newSelectedObj.selectedImgFile12 != null) {
                    formData.append('pic_12', this.newSelectedObj.selectedImgFile12, 'pic_12.png')
                }

                if (this.newSelectedObj.selectedImgFile13 != null) {
                    formData.append('pic_13', this.newSelectedObj.selectedImgFile13, 'pic_13.png')
                }

                if (this.newSelectedObj.selectedImgFile14 != null) {
                    formData.append('pic_14', this.newSelectedObj.selectedImgFile14, 'pic_14.png')
                }

                if (this.newSelectedObj.selectedImgFile15 != null) {
                    formData.append('pic_15', this.newSelectedObj.selectedImgFile15, 'pic_15.png')
                }

                if (this.newSelectedObj.status != null) {
                    formData.append('status', this.newSelectedObj.status);
                }

                if (this.newSelectedObj.status_2 != null) {
                    formData.append('status_2', this.newSelectedObj.status_2);
                }

                if (this.newSelectedObj.status_3 != null) {
                    formData.append('status_3', this.newSelectedObj.status_3);
                }

                if (this.newSelectedObj.remarks != null) {
                    formData.append('remarks', this.newSelectedObj.remarks);
                }

                if (this.newSelectedObj.remarks_2 != null) {
                    formData.append('remarks_2', this.newSelectedObj.remarks_2);
                }

                if (this.newSelectedObj.remarks_3 != null) {
                    formData.append('remarks_3', this.newSelectedObj.remarks_3);
                }

                if (this.newSelectedObj.remarks_4 != null) {
                    formData.append('remarks_4', this.newSelectedObj.remarks_4);
                }

                if (this.newSelectedObj.remarks_5 != null) {
                    formData.append('remarks_5', this.newSelectedObj.remarks_5);
                }
                
                if (this.newSelectedObj.followed_up != null) {
                    formData.append('followed_up', this.newSelectedObj.followed_up);
                }

                if (this.newSelectedObj.followed_up_2 != null) {
                    formData.append('followed_up_2', this.newSelectedObj.followed_up_2);
                }

                if (this.newSelectedObj.followed_up_3 != null) {
                    formData.append('followed_up_3', this.newSelectedObj.followed_up_3);
                }

                if (this.newSelectedObj.followed_up_4 != null) {
                    formData.append('followed_up_4', this.newSelectedObj.followed_up_4);
                }

                if (this.newSelectedObj.followed_up_5 != null) {
                    formData.append('followed_up_5', this.newSelectedObj.followed_up_5);
                }

                if (this.newSelectedObj.pm_type != null) {
                    formData.append('pm_type', this.newSelectedObj.pm_type);
                }

                if (this.newSelectedObj.num_of_old_sponge != null) {
                    formData.append('num_of_old_sponge', this.newSelectedObj.num_of_old_sponge);
                }

                if (this.newSelectedObj.num_of_new_sponge != null) {
                    formData.append('num_of_new_sponge', this.newSelectedObj.num_of_new_sponge);
                }

                if (this.newSelectedObj.created_by != null) {
                    formData.append('created_by', this.newSelectedObj.created_by);
                }
                
                console.log(this.newSelectedObj);
              
                this.$store.dispatch(ACTION_CK_EM_ATC_ADD_NEW_ATC, formData)

                this.newSelectedObj = {
                    checklist_no: null,
                    ck_form_id: null,
                    date: null,
                    time: null,
                    station_id: null,

                    comments: 'All ATC Systems are running in normal working conditions.  ',
                    selectedImgFile1: null,
                    pic_1: null,
                    selectedImgFile2: null,
                    pic_2: null,
                    selectedImgFile3: null,
                    pic_3: null,
                    selectedImgFile4: null,
                    pic_4: null,
                    selectedImgFile5: null,
                    pic_5: null,
                    selectedImgFile6: null,
                    pic_6: null,
                    selectedImgFile7: null,
                    pic_7: null,
                    selectedImgFile8: null,
                    pic_8: null,
                    selectedImgFile9: null,
                    pic_9: null,
                    selectedImgFile10: null,
                    pic_10: null,
                    selectedImgFile11: null,
                    pic_11: null,
                    selectedImgFile12: null,
                    pic_12: null,
                    selectedImgFile13: null,
                    pic_13: null,
                    selectedImgFile14: null,
                    pic_14: null,
                    selectedImgFile15: null,
                    pic_15: null,

                    status: null,
                    status_2: null,
                    status_3: null,
                    
                    remarks: null,
                    remarks_2: null,
                    remarks_3: null,
                    remarks_4: null,
                    remarks_5: null,

                    followed_up: null,
                    followed_up_2: null,
                    followed_up_3: null,
                    followed_up_4: null,
                    followed_up_5: null,

                    atcs_type: null,

                    num_of_old_sponge: null,
                    num_of_new_sponge: null,

                    created_by: null
                };

                this.openAddDialog = false
            },
            editResourceAction: function () {
                const formData = new FormData();
                formData.append('atc_id', this.selectedObj.id);

                if (this.selectedObj.checklist_no != null) {
                    formData.append('checklist_no', this.selectedObj.checklist_no);
                }

                if (this.selectedObj.ck_form_id != null) {
                    formData.append('ck_form_id', this.selectedObj.ck_form_id);
                }

                if (this.selectedObj.station_id != null) {
                    formData.append('station_id', this.selectedObj.station_id);
                }

                if (this.selectedObj.date != null) {
                    formData.append('date', this.selectedObj.date);
                }

                if (this.selectedObj.time != null) {
                    formData.append('time', this.selectedObj.time);
                }

                if (this.selectedObj.comments != null) {
                    formData.append('comments', this.selectedObj.comments);
                }

                if (this.selectedObj.selectedImgFile1 != null) {
                    formData.append('pic_1', this.selectedObj.selectedImgFile1, 'pic_1.png')
                }

                if (this.selectedObj.selectedImgFile2 != null) {
                    formData.append('pic_2', this.selectedObj.selectedImgFile2, 'pic_2.png')
                }

                if (this.selectedObj.selectedImgFile3 != null) {
                    formData.append('pic_3', this.selectedObj.selectedImgFile3, 'pic_3.png')
                }

                if (this.selectedObj.selectedImgFile4 != null) {
                    formData.append('pic_4', this.selectedObj.selectedImgFile4, 'pic_4.png')
                }

                if (this.selectedObj.selectedImgFile5 != null) {
                    formData.append('pic_5', this.selectedObj.selectedImgFile5, 'pic_5.png')
                }

                if (this.selectedObj.selectedImgFile6 != null) {
                    formData.append('pic_6', this.selectedObj.selectedImgFile6, 'pic_6.png')
                }

                if (this.selectedObj.selectedImgFile7 != null) {
                    formData.append('pic_7', this.selectedObj.selectedImgFile7, 'pic_7.png')
                }

                if (this.selectedObj.selectedImgFile8 != null) {
                    formData.append('pic_8', this.selectedObj.selectedImgFile8, 'pic_8.png')
                }

                if (this.selectedObj.selectedImgFile9 != null) {
                    formData.append('pic_9', this.selectedObj.selectedImgFile9, 'pic_9.png')
                }

                if (this.selectedObj.selectedImgFile10 != null) {
                    formData.append('pic_10', this.selectedObj.selectedImgFile10, 'pic_10.png')
                }

                if (this.selectedObj.selectedImgFile11 != null) {
                    formData.append('pic_11', this.selectedObj.selectedImgFile11, 'pic_11.png')
                }

                if (this.selectedObj.selectedImgFile12 != null) {
                    formData.append('pic_12', this.selectedObj.selectedImgFile12, 'pic_12.png')
                }

                if (this.selectedObj.selectedImgFile12 != null) {
                    formData.append('pic_12', this.selectedObj.selectedImgFile12, 'pic_12.png')
                }

                if (this.selectedObj.selectedImgFile13 != null) {
                    formData.append('pic_13', this.selectedObj.selectedImgFile13, 'pic_13.png')
                }

                if (this.selectedObj.selectedImgFile14 != null) {
                    formData.append('pic_14', this.selectedObj.selectedImgFile14, 'pic_14.png')
                }

                if (this.selectedObj.selectedImgFile15 != null) {
                    formData.append('pic_15', this.selectedObj.selectedImgFile15, 'pic_15.png')
                }

                if (this.selectedObj.status != null) {
                    formData.append('status', this.selectedObj.status);
                }

                if (this.selectedObj.status_2 != null) {
                    formData.append('status_2', this.selectedObj.status_2);
                }

                if (this.selectedObj.status_3 != null) {
                    formData.append('status_3', this.selectedObj.status_3);
                }

                if (this.selectedObj.remarks != null) {
                    formData.append('remarks', this.selectedObj.remarks);
                }

                if (this.selectedObj.remarks_2 != null) {
                    formData.append('remarks_2', this.selectedObj.remarks_2);
                }

                if (this.selectedObj.remarks_3 != null) {
                    formData.append('remarks_3', this.selectedObj.remarks_3);
                }

                if (this.selectedObj.remarks_4 != null) {
                    formData.append('remarks_4', this.selectedObj.remarks_4);
                }

                if (this.selectedObj.remarks_5 != null) {
                    formData.append('remarks_5', this.selectedObj.remarks_5);
                }
                
                if (this.selectedObj.followed_up != null) {
                    formData.append('followed_up', this.selectedObj.followed_up);
                }

                if (this.selectedObj.followed_up_2 != null) {
                    formData.append('followed_up_2', this.selectedObj.followed_up_2);
                }

                if (this.selectedObj.followed_up_3 != null) {
                    formData.append('followed_up_3', this.selectedObj.followed_up_3);
                }

                if (this.selectedObj.followed_up_4 != null) {
                    formData.append('followed_up_4', this.selectedObj.followed_up_4);
                }

                if (this.selectedObj.followed_up_5 != null) {
                    formData.append('followed_up_5', this.selectedObj.followed_up_5);
                }

                if (this.selectedObj.pm_type != null) {
                    formData.append('pm_type', this.selectedObj.pm_type);
                }

                if (this.selectedObj.num_of_old_sponge != null) {
                    formData.append('num_of_old_sponge', this.selectedObj.num_of_old_sponge);
                }

                if (this.selectedObj.num_of_new_sponge != null) {
                    formData.append('num_of_new_sponge', this.selectedObj.num_of_new_sponge);
                }

                if (this.selectedObj.created_by != null) {
                    formData.append('created_by', this.selectedObj.created_by);
                }
                  
                
                this.$store.dispatch(ACTION_CK_EM_ATC_UPDATE_ATC, formData)

                this.openEditDialog = false
            },
            deleteResourceAction: function (id) {
                let payload = {
                    atc_id: id
                }
                this.$store.dispatch(ACTION_CK_EM_ATC_DELETE_ATC, payload)
                this.openDeleteDialog = false
            },
            // bulk edit
            toggleAll () {
                if (this.selected.length) {
                    this.selected = []
                }
                else {
                    this.selected = this.items.slice()
                }
            },
            navigateToBulkDialogPage: function () {
                let vm = this
                vm.selectedFormID = []
                vm.selected.forEach(function (singleForm) {
                    vm.selectedFormID.push(singleForm.id);
                });

                vm.$router.push({ 
                    name: 'SBST Bulk Sign CheckList Forms', 
                    query: { 
                        format_id: vm.checklist_format_id,
                        selected_forms: vm.selectedFormID
                    } 
                });
            },
            downloadReportNow: async function (item) {
                this.selectedObj = item;
                if (this.selectedObj.pic1 != null) {
                    let base64image = await this.getBase64Image(this.selectedObj.pic1).then(function(base64image) {
                        this.selectedObj.pic1 = base64image;
                    },  function(reason) {
                        console.log(reason); // Error!
                    });
                }
                this.$refs.html2Pdf.generatePdf();
            }
        },
        components: {
            appVuePagination: VuePagination,
            appVueHtml2pdf: VueHtml2pdf,
        }
    }
</script>

<style lang="css" scoped>
    .signature_box {
        border-style: solid;
    }

    .subTitle {
        margin-top: 10px;
        margin-left: -15px;
    }

    table.myFormTable {
        font-family: arial, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    table.myFormTable > tbody > tr > td, table.myFormTable > thead > tr >th {
        border: 1px solid #dddddd;
        text-align: left;
        padding: 8px;
    }

    table.myFormTable > tr:nth-child(even) {
        background-color: #dddddd;
    }

    .sectionHeader {
        width: 100%;
        text-align: center;
        color: white;
        background-color: #075e54;
        font-size: 16.0;
        font-weight: 600;
        padding: 10px;
        box-sizing: border-box;
        box-shadow: 2px ;
    }

    .addPhotoTitle {
        width: 100%;
        text-align: center;
        padding: 10px;
        color: black;
        box-sizing: border-box;
        box-shadow: 2px ;
        font-size: 14.0;
    }

    .imgContainer {
        width: 100%;
        height: 300px;
        padding-left: 20%;
        padding-top: 5%;
        border: 1px solid gray;
        display: flex;
        align-items: flex-start;
        text-align: center;
    }

    .imgF {
        align-self: center;
        margin: 0 auto;
        width: 250px;
        height: 250px;
    }

    /* pdf  */
    .border-container {
        border: 2px solid #000;
        margin: 2%;
        height: 100%;
        width: 95%;
    }

    .pdf-header {
        width: 100%;
        margin: auto;
        text-align: center;
        justify-content: center;
        color: #000;
    }

    .textBlack {
        color: #000000;
    }

    table.pdf {
        border-collapse: collapse;
        width: 100%
    }

    table.pdf, table.pdf th, table.pdf td {
        border: 1px solid black;
        padding: 5px;
    }

    .tableTextCenter{
        margin: auto;
        text-align: center;
        justify-content: center;
    }

</style>